var React = require('react');

function ZoomIn24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15,18c-2,0-3.8-0.6-5.2-1.7c-1,1.3-2.1,2.8-3.5,4.6c-2.2,2.8-3.4,1.9-3.4,1.9s-0.6-0.3-1.1-0.7\r\n\tc-0.4-0.4-0.7-1-0.7-1s-0.9-1.2,1.9-3.3c1.8-1.4,3.3-2.5,4.6-3.5C6.6,12.8,6,11,6,9c0-5,4-9,9-9s9,4,9,9S20,18,15,18z M15,2\r\n\tc-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S18.9,2,15,2z M16,13h-2v-3h-3V8h3V5h2v3h3v2h-3V13z"}));
}

ZoomIn24.defaultProps = {"width":"24","height":"24"};

module.exports = ZoomIn24;

ZoomIn24.default = ZoomIn24;
